import ipAddress from './svgs/ip-address.svg';
import paylink from './svgs/paylink.svg';
import webhooks from './svgs/webhooks.svg';
import approvalSettings from './svgs/approval-settings.svg';
import brandSettings from './svgs/brand-settings.svg';
import domainSetup from './svgs/domain-setup.svg';
import preFunding from './svgs/pre-funding.svg';

export type SettingsCardImgs =
  | 'domainSetup'
  | 'approvalSettings'
  | 'ipAddress'
  | 'paylink'
  | 'webhooks'
  | 'brandSettings'
  | 'preFunding';
export const SettingsCardImgsMap: { [key in SettingsCardImgs]: { src: string; alt: string } } = {
  domainSetup: {
    src: domainSetup,
    alt: 'domain setup',
  },
  approvalSettings: {
    src: approvalSettings,
    alt: 'Approval Settings',
  },
  brandSettings: {
    src: brandSettings,
    alt: 'Brand Settings',
  },
  ipAddress: {
    src: ipAddress,
    alt: 'IP Address',
  },
  paylink: {
    src: paylink,
    alt: 'paylink',
  },
  webhooks: {
    src: webhooks,
    alt: 'Webhooks',
  },
  preFunding: {
    src: preFunding,
    alt: 'Pre-Funding Settings',
  },
};
